import React from 'react'
import { StyledMuvibusInfo } from './styles.style'
import { content } from '../../../../../config'

const { BRAND_NAME, CHIPEST, IS_DIGITAL, RELIBLE, TRAVEL, EASY_PURCHASE } =
	content

const AdvantagesPage = () => {
	return (
		<StyledMuvibusInfo>
			<div className="title-info">
				<div>Vamos de {BRAND_NAME}!</div>
				<div>Conheça nossos diferenciais</div>
			</div>
			<div className="content">
				<div>
					<h3>MAIS BARATO</h3>
					<p>{CHIPEST}</p>
				</div>
				<div>
					<h3>100% DIGITAL</h3>
					<p>{IS_DIGITAL}</p>
				</div>
				<div>
					<h3>CONFIÁVEL</h3>
					<p>{RELIBLE}</p>
				</div>
				<div>
					<h3>VIAJE E GANHE</h3>
					<p>{TRAVEL}</p>
				</div>
				<div>
					<h3>COMPRA FÁCIL</h3>
					<p>{EASY_PURCHASE}</p>
				</div>
			</div>
		</StyledMuvibusInfo>
	)
}

export default AdvantagesPage
